import React, { useRef, useState } from "react";
import "./Timeline.scss";

const LeftArrow = `${process.env.REACT_APP_S3_URL}LeftArrowBlack.svg`;
const LeftArrowActive = `${process.env.REACT_APP_S3_URL}LeftArrowPink.svg`;
const RightArrowActive = `${process.env.REACT_APP_S3_URL}RightArrowPink.svg`;
const RightArrow = `${process.env.REACT_APP_S3_URL}rightArrowBlack.svg`;

interface CardData {
  icon: string;
  title: string;
  description: string;
  isSelected: boolean;
  isComingSoon: boolean;
}

interface CardsDataProps {
  hostedHeaderName: string;
  cardData: CardData[];
}

const Timeline: React.FC<CardsDataProps> = ({ hostedHeaderName, cardData }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  
  const handlePageChange = (direction: 'left' | 'right', isMobile: boolean) => {
      setCurrentPage((prev: number) => {
          if (direction === 'left' && prev > 1) return prev - 1;
          if (direction === 'right' && prev < Math.ceil(cardData.length / (isMobile && 1 || 3))) return prev + 1;
          return prev; // Ensure a number is always returned
      });
      scrollCards(direction, isMobile);
  }

  // Type definition for the scroll direction
  const scrollCards = (direction: 'left' | 'right', isMobile: boolean) => {
      console.log('waiting here', direction);
  
      if (scrollContainerRef.current) {
          const card = scrollContainerRef.current.querySelector<HTMLDivElement>('.timeline-item');
          
          if (card) {
              const cardStyle = window.getComputedStyle(card);
              const cardWidth = card.offsetWidth 
                  + parseInt(cardStyle.marginLeft) 
                  + parseInt(cardStyle.marginRight);
  
              console.log('Adjusted cardWidth:', cardWidth);
              const scrollAmount = cardWidth * (isMobile && 1 || 3); // Scroll 3 cards at a time
              
              scrollContainerRef.current.scrollBy({
                  left: direction === 'left' ? -scrollAmount : scrollAmount,
                  behavior: 'smooth',
              });
          }
      }
  };

  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="page-header">
              <div>
                <h3>Hosted <span className="highlight">{hostedHeaderName} </span>Offering</h3>
              </div>
              <div className='arrows'>
                    <img
                        onClick={() => currentPage > 1 && handlePageChange('left', false)}
                        style={{ cursor: currentPage > 1 ? 'pointer' : 'default' }}
                        src={currentPage > 1 ? LeftArrowActive : LeftArrow}
                        alt=''
                    />
                    <span className='test-len'>{currentPage}/{Math.ceil(cardData.length / 3)}</span>
                    <img
                        onClick={() => currentPage < Math.ceil(cardData.length / 3) && handlePageChange('right', false)}
                        style={{ cursor: currentPage < Math.ceil(cardData.length / 3) ? 'pointer' : 'default' }}
                        src={currentPage < Math.ceil(cardData.length / 3) ? RightArrowActive : RightArrow}
                        alt=''
                    />
                </div>
            </div>
            <div className="timeline-container" ref={scrollContainerRef}>
              <ul className="timeline timeline-horizontal" >
                {cardData.map((card) => {
                  return (
                    <li className="timeline-item" key={card.title}>
                      <div className="timeline-panel">
                        <div className="timeline-heading">
                          <div className="timeline-image">
                            <img src={card.icon} alt="card icon"></img>
                          </div>
                          <h4 className="timeline-title">{card.title}</h4>
                        </div>
                        <div className="timeline-body">
                          <p>{card.description}</p>
                        </div>
                      </div>
                      <div className="timeline-badge"></div>
                      <div className="vertical-line">
                      </div>
                      { card.isComingSoon && <div className="coming-soon-badge"><span className="coming-soon-badge-text">Coming soon</span></div> }
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="arrows-mobile-container">
              <div className='arrows-mobile'>
                    <img
                        onClick={() => currentPage > 1 && handlePageChange('left', true)}
                        style={{ cursor: currentPage > 1 ? 'pointer' : 'default' }}
                        src={currentPage > 1 ? LeftArrowActive : LeftArrow}
                        alt=''
                    />
                    <span className='test-len'>{currentPage}/{cardData.length}</span>
                    <img
                        onClick={() => currentPage < cardData.length && handlePageChange('right', true)}
                        style={{ cursor: currentPage < cardData.length ? 'pointer' : 'default' }}
                        src={currentPage < cardData.length ? RightArrowActive : RightArrow}
                        alt=''
                    />
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timeline;
